import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const BattingOrderPage = () => {
  useEffect(() => {
    document.title = 'Batting | SportsTMS | THE OFFICIAL SPORTS MANAGEMENT SYSTEM';
    
    const cssFiles = [
      'https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css',
      'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css',
      '/css/screen_layout_mega.css',
      '/css/default.css', 
      '/css/component.css',
      '/css/slimmenu.css'
    ];

    cssFiles.forEach(href => {
      if (!document.querySelector(`link[href="${href}"]`)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        document.head.appendChild(link);
      }
    });

    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) {
          resolve();
          return;
        }
        const script = document.createElement('script');
        script.src = src;
        script.onload = () => resolve();
        script.onerror = () => reject();
        document.head.appendChild(script);
      });
    };

    const initializeMenu = async () => {
      try {
        await loadScript('/js/jquery.min.js');
        await loadScript('/js/jquery.slimmenu.js');
        
        setTimeout(() => {
          if (window.$ && typeof window.$.fn.slimmenu === 'function') {
            window.$('ul.slimmenu').slimmenu({
              resizeWidth: '1100',
              collapserTitle: 'Main Menu',
              easingEffect: 'easeInOutQuint',
              animSpeed: 'medium',
              indentChildren: true,
              childrenIndenter: '&raquo;'
            });
          }
        }, 300);
      } catch (error) {
        console.error('Error loading scripts:', error);
      }
    };

    initializeMenu();

    return () => {
      if (window.$ && window.$('ul.slimmenu').length > 0) {
        try {
          window.$('ul.slimmenu').off();
        } catch (e) {}
      }
    };
  }, []);

  return (
    <div id="outer_m">
      {/* Header */}
      <header>
        <div id="zero">
          <img className="logo" src="/logo.png" alt="SportsTMS Logo" />
        </div>
        <div id="one">
          <div id="two">Sports Tournament Management System</div>
          <div id="three">THE OFFICIAL SITE OF INDIAN BASEBALL</div>
        </div>
        <img className="" src="/second_logo.png" alt="Secondary Logo" />
      </header>

      {/* Navigation */}
      <nav>
        <ul className="slimmenu">
          <li>
            <Link to="/">
              <span className="glyphicon glyphicon-home" style={{fontSize: '15px'}}></span>
            </Link>
          </li>
          <li>
            <a href="#">About</a>
            <ul>
              <li><a href="/history">History</a></li>
              <li><a href="/pdf/Amateur_Baseball_federation.zip">Constitution</a></li>
              <li><a href="/international-recognition">International Recognition</a></li>
              <li><a href="/registration">Registration</a></li>
              <li><Link to="/affiliates">Affiliates</Link></li>
              <li><Link to="/bearer">Executive Committee</Link></li>
            </ul>
          </li>
          <li>
            <a href="#">Rules</a>
            <ul>
              <li>
                <a href="#">Basics</a>
                <ul>
                  <li><Link to="/score-keeping">Keeping Score</Link></li>
                  <li><Link to="/baseball-lingo">Baseball Lingo</Link></li>
                  <li><Link to="/abbreviation">Abbreviation</Link></li>
                  <li><Link to="/stats">Stats 101</Link></li>
                </ul>
              </li>
              <li><Link to="/rules">Baseball Rules</Link></li>
              <li>
                <a href="#">Play Baseball</a>
                <ul>
                  <li><Link to="/skills">4 Skills of Baseball</Link></li>
                  <li><Link to="/batting-order">Batting Order</Link></li>
                  <li><Link to="/fielding-position">Fielding Position</Link></li>
                  <li><Link to="/why-play">Why Play Baseball</Link></li>
                  <li><a href="/pdf/manual.pdf" target="_blank">Manual</a></li>
                </ul>
              </li>
              <li><a href="/pdf/manual_baseball.pdf" target="_blank">Manual</a></li>
            </ul>
          </li>
          <li><a href="/events">Events</a></li>
          <li>
            <a href="#">Schedule</a>
            <ul>
              <li><a href="/forthcoming-events">Forthcoming Events</a></li>
              <li><a href="/calendar-events">Calendar Events</a></li>
            </ul>
          </li>
          <li>
            <a href="#">Participants</a>
            <ul>
              <li><a href="/admin-login">User Login</a></li>
              <li><a href="#">Roster</a></li>
              <li><a href="/certificate-verify">Certificates</a></li>
            </ul>
          </li>
          <li>
            <a href="#">Information</a>
            <ul>
              <li><a href="/committees">Committees</a></li>
              <li><a href="/accounts">Accounts</a></li>
              <li><a href="/rti">RTI</a></li>
              <li><a href="/website-info">Website information</a></li>
            </ul>
          </li>
          <li>
            <a href="#">Downloads</a>
            <ul>
              <li><a href="/pdf/Roster_form.pdf" target="_blank">Roster form</a></li>
              <li><a href="/pdf/team_Roster.pdf" target="_blank">Team roster</a></li>
              <li><a href="/pdf/Score_Sheet.pdf" target="_blank">Score sheet</a></li>
            </ul>
          </li>
          <li><a href="/photo-gallery">Gallery</a></li>
          <li><a href="/contact">Contact Us</a></li>
        </ul>
      </nav>

      {/* Main Content */}
      <div id="main">
        <div id="stickleft">
          <i className="fa fa-facebook-square" style={{fontSize: '32px', marginLeft: '2px', cursor: 'pointer', color: '#2d3e50'}}></i>
          <i className="fa fa-youtube-square" style={{fontSize: '32px', marginLeft: '2px', cursor: 'pointer', color: '#2d3e50'}}></i>
          <i className="fa fa-twitter-square" style={{fontSize: '32px', marginLeft: '2px', cursor: 'pointer', color: '#2d3e50'}}></i>
          <i className="fa fa-linkedin-square" style={{fontSize: '32px', marginLeft: '2px', cursor: 'pointer', color: '#2d3e50'}}></i>
        </div>

        <a href="/about"><div id="stick_right"></div></a>
        <br /><br />

        <div className="col-lg-12">
          <div className="panel panel-default">
            <div className="panel-heading">
              <h3 className="heading3">BATTING ORDER</h3>
            </div>
            <div className="panel-body">
              <p className="depart_p">A team should let its best hitters and runners bat first, because they will get to bat more often during a game. Here are some tips for a strong batting order.</p>
              <hr />

              <p className="depart_p">
                <strong>First Batter</strong> - Usually small and fast with a good eye. This is an excellent spot for a left hander<br />
                <strong>Second Batter</strong> - A good bunter and fast runner.<br />
                <strong>Third batter</strong> - Best hitter, he hits the ball often.<br />
                <strong>Fourth Batter</strong> - Good hitter with men on base.<br />
                <strong>Fifth batter</strong> - Long ball hitter, aggressive hitter.<br />
                <strong>Sixth batter</strong> - Fairly good hitter with speed.<br />
                <strong>Seventh Batter</strong> - Fairly good hitter.<br />
                <strong>Eighth Batter</strong> - An inexperienced player with promise.<br />
                <strong>Ninth Batter</strong> - A good fielder.
              </p>
            </div>
          </div>
        </div>

        <div className="col-lg-12">
          <div className="panel panel-default">
            <div className="panel-heading">
              <h3 className="heading3">BATTING ORDER</h3>
            </div>
            <div className="panel-body">
              <p className="depart_p">A baseball team must be strong down the middle. That means it must have a good pitcher, catcher, shortstop, second baseman, and center fielder. Next in order come the first baseman, third baseman, left fielder, and right fielder.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer>
        <div id="outer_main">
          <div id="outer1">
            <div id="aku11">
              <h4 className="link_heading">LOCATION</h4>
              <h4 className="ft">B4/317B, Keshav Puram,<br />Delhi - 110035</h4>
            </div>
            <div id="aku22">
              <h4 className="link_heading">AROUND THE WEB</h4>
              <div id="social">
                <div id="contact_a_dn">
                  <div className="sl sl2"><i className="fa fa-facebook-f" style={{fontSize: '16px', color: 'white', marginTop: '8px'}}></i></div>
                  <div className="sl sl3"><i className="fa fa-youtube-play" style={{fontSize: '16px', color: 'white', marginTop: '8px'}}></i></div>
                  <div className="sl sl4"><i className="fa fa-twitter" style={{fontSize: '16px', color: 'white', marginTop: '8px'}}></i></div>
                  <div className="sl sl5"><i className="fa fa-linkedin" style={{fontSize: '16px', color: 'white', marginTop: '8px'}}></i></div>
                </div>
              </div>
            </div>
            <div id="aku33">
              <h4 className="link_heading">CONTACT US</h4>
              <label className="ft">Phone : +918890029024, +919165276531<br />Email: abfi.secretarygeneral@gmail.com</label>
            </div>
          </div>
        </div>
        <div id="main_link">
          <div id="main_link_inner">
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/rules">Rules</a></li>
              <li><a href="/events">Events</a></li>
              <li><a href="/schedule">Schedule</a></li>
              <li><a href="/affiliates">Affiliates</a></li>
              <li><a href="/photo-gallery">Gallery</a></li>
              <li><a href="/contact">Contact Us</a></li>
            </ul>
            <ul>
              <li><a href="/international-recognition">International & Recognition</a></li>
              <li><a href="/international-recognition-bfa">International & Recognition BFA</a></li>
              <li><a href="/pdf/voting_rights.pdf" target="_blank">Voting Rights</a></li>
              <li><a href="/registration">Certificate of Registration</a></li>
              <li><a href="/international-participation">International Participation</a></li>
              <li><a href="/pdf/ABFI_constitution.pdf">Constitution</a></li>
              <li><a href="/affiliates">Affiliated Units</a></li>
              <li><a href="#">Firm Name</a></li>
              <li><a href="#">Media Coverage</a></li>
              <li><a href="/committees">Committees</a></li>
              <li><a href="/accounts">Accounts</a></li>
              <li><a href="/rti">RTI</a></li>
              <li><a href="/calendar-events">Calendar Events</a></li>
              <li><a href="/pdf/manual_baseball.pdf" target="_blank">Manuals</a></li>
              <li><a href="/history">History</a></li>
              <li><a href="/bearer">Executive Committee</a></li>
              <li><a href="/website-info">Website Info</a></li>
            </ul>
            <div className="text-center">
              <hr />
              <p style={{color: '#fff'}}>For best results use Mozilla or Chrome browsers</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default BattingOrderPage;